import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainRootComponent } from './pages/main.page/components/main-root/main-root.component';
import { ShareRootComponent } from './pages/share-root/share-root.component';

const routes: Routes = [
  { path: '', component: MainRootComponent },
  { path: 'share', component: ShareRootComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
